
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, February 23, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "groupformlist",
	init: init,
	uninit: uninit,
	listeners: listeners,

	refresh: refresh,
	_loaded: false,
	_isStaff: false,
	_group: null,
	_group_tracker: null,
});

function init() {
	this._group_tracker = this.dispatcher.createTracker();
	this.push({});
}

function uninit() {
	this._group_tracker.off();
	this._group_tracker = null;
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"personal:updated": handle_personal_update,
		"orggroup:updated": handle_org_group_update,
	};
}

function handle_org_group_update(group){
	if(!group) return;
	if(this._group === group) return;
	var tracker = this._group_tracker;
	tracker.off();
	tracker.on("mqtt:orggroup/" + group + "/forms/definitions/created", handle_definition_created.bind(this));
	tracker.on("mqtt:orggroup/" + group + "/forms/definitions/updated", handle_definition_updated.bind(this));
}

function handle_definition_created(definition){
	if(definition.targetType !== "group") return;
	var update = {};
	update[definition._id] = definition;
	this.extend(update);
}

function handle_definition_updated(definition){
	if(definition.targetType !== "group") {
		var copy = xtend(this.data);
		delete copy[definition._id];
		this.push(copy);
		return;
	}
	var update = {};
	update[definition._id] = definition;
	this.extend(update);
}

function handle_personal_update(person){
	var type = person.type;
	if(!type) return;
	this._isStaff = (type.indexOf("staff") !== -1) ? true : false;
	if(this._loaded || !this._isStaff) return;
	this.refresh();
}

function refresh() {
	if(!this._isStaff) return;
	this.api.forms.list.group().then(handle_forms.bind(this));
}

function handle_forms(forms) {
	this.push(forms.reduce(function (result, form) {
		var update = {};
		update[form._id] = form;
		return xtend(result, update);
	}, {}));
	this._loaded = true;
}
